/* ============================================================
   VizABull — Bug Season Landing : interactivity
   - bundle selection (4-pack default)
   - add to cart + drawer + qty
   - sticky scroll CTA bar
   - FAQ accordion
   ============================================================ */
(function () {
  "use strict";

  var PACKS = {
    "4pack":  { label: "4-Pack",     price: 59.96,  meta: "4 cans · $11.99/can", btn: "Add To Cart" },
    "12pack": { label: "12-Pack",    price: 119.88, meta: "12 cans · $9.99/can", btn: "Add To Cart" }
  };

  var cart = {};            // id -> qty
  var selected = "4pack";   // currently selected bundle (4-pack leads)

  var money = function (n) { return "$" + n.toFixed(2); };

  /* ---------- bundle selection ---------- */
  var packEls = Array.prototype.slice.call(document.querySelectorAll(".pack"));
  function select(id) {
    selected = id;
    packEls.forEach(function (el) {
      var on = el.getAttribute("data-pack") === id;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-checked", on ? "true" : "false");
    });
    document.getElementById("sbPack").textContent = PACKS[id].label;
    document.getElementById("sbPrice").textContent =
      money(PACKS[id].price) + (PACKS[id].ship ? " + ship" : "");
    document.getElementById("sbAdd").textContent = PACKS[id].btn || "Add To Cart";
  }
  packEls.forEach(function (el) {
    var id = el.getAttribute("data-pack");
    // click anywhere on card (except the add button) selects it
    el.addEventListener("click", function (e) {
      if (e.target.closest("[data-add]")) return;
      select(id);
    });
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(id); }
    });
  });

  /* ---------- cart ---------- */
  var cartEl    = document.getElementById("cart");
  var scrimEl   = document.getElementById("cartScrim");
  var bodyEl    = document.getElementById("cartBody");
  var totalEl   = document.getElementById("cartTotal");
  var countEl   = document.getElementById("cartCount");

  function openCart()  { cartEl.classList.add("is-open"); scrimEl.classList.add("is-open"); }
  function closeCart() { cartEl.classList.remove("is-open"); scrimEl.classList.remove("is-open"); }

  function addToCart(id) {
    if (!PACKS[id]) return;
    // single can routes to its own SKU page instead of the cart
    if (PACKS[id].link) { window.location.hash = PACKS[id].link.replace(/^#/, ""); select(id); return; }
    cart[id] = (cart[id] || 0) + 1;
    select(id);          // reflect the chosen pack in selection + sticky bar
    renderCart();
    openCart();
  }

  function renderCart() {
    var ids = Object.keys(cart).filter(function (id) { return cart[id] > 0; });
    var count = 0, total = 0;
    ids.forEach(function (id) { count += cart[id]; total += cart[id] * PACKS[id].price; });

    countEl.textContent = count;
    countEl.setAttribute("data-empty", count === 0 ? "true" : "false");
    totalEl.textContent = money(total);

    if (ids.length === 0) {
      bodyEl.innerHTML =
        '<div class="cart__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
        "<p>Your cart is empty.<br>Bug season won't wait.</p></div>";
      return;
    }

    bodyEl.innerHTML = ids.map(function (id) {
      var p = PACKS[id], q = cart[id];
      return '' +
        '<div class="cline">' +
          '<div class="cline__thumb"><img src="' + ((window.__resources && window.__resources.canThumb) || 'https://bullsnot.com/cdn/shop/t/9/assets/bsn-vb-can-clean.png') + '" alt=""></div>' +
          '<div class="cline__body">' +
            '<div class="cline__name">VizABull ' + p.label + '</div>' +
            '<div class="cline__meta">' + p.meta + '</div>' +
            '<div class="cline__qty" data-id="' + id + '">' +
              '<button data-step="-1" aria-label="Decrease">–</button>' +
              '<span>' + q + '</span>' +
              '<button data-step="1" aria-label="Increase">+</button>' +
            '</div>' +
            '<button class="cline__remove" data-remove="' + id + '">Remove</button>' +
          '</div>' +
          '<div class="cline__price">' + money(q * p.price) + '</div>' +
        '</div>';
    }).join("");
  }

  // qty / remove (event delegation)
  bodyEl.addEventListener("click", function (e) {
    var step = e.target.closest("[data-step]");
    if (step) {
      var id = step.parentNode.getAttribute("data-id");
      cart[id] = Math.max(0, (cart[id] || 0) + parseInt(step.getAttribute("data-step"), 10));
      if (cart[id] === 0) delete cart[id];
      renderCart();
      return;
    }
    var rem = e.target.closest("[data-remove]");
    if (rem) { delete cart[rem.getAttribute("data-remove")]; renderCart(); }
  });

  // any [data-add] button adds its pack
  document.querySelectorAll("[data-add]").forEach(function (btn) {
    btn.addEventListener("click", function () { addToCart(btn.getAttribute("data-add")); });
  });

  // sticky bar add -> uses currently selected pack (single can routes to its SKU)
  document.getElementById("sbAdd").addEventListener("click", function () { addToCart(selected); });

  document.getElementById("cartOpen").addEventListener("click", openCart);
  document.getElementById("cartClose").addEventListener("click", closeCart);
  scrimEl.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  /* ---------- sticky scroll CTA bar ---------- */
  var sticky = document.getElementById("stickybar");
  var hero = document.getElementById("top");
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { sticky.classList.toggle("is-on", !en.isIntersecting); });
  }, { rootMargin: "-120px 0px 0px 0px" });
  io.observe(hero);

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll(".faq__item").forEach(function (item) {
    var q = item.querySelector(".faq__q");
    var a = item.querySelector(".faq__a");
    q.addEventListener("click", function () {
      var open = item.classList.contains("is-open");
      // close siblings for a clean single-open accordion
      document.querySelectorAll(".faq__item.is-open").forEach(function (o) {
        if (o !== item) { o.classList.remove("is-open"); o.querySelector(".faq__a").style.maxHeight = null; }
      });
      if (open) { item.classList.remove("is-open"); a.style.maxHeight = null; }
      else      { item.classList.add("is-open");   a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });

  // init
  select("4pack");
  renderCart();
})();
